import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { showPromo, loadPromos } from './actions';
import { showedPromo } from 'components/link/actions';
import { track } from 'shared/models/analytic';
import Modal from 'scy/Modal';
import { LightBackground } from 'scy/Background';
import { Body, H5, Small, SecondarySmallUppercase } from 'scy/text';
import PromoForm from './form';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';
import { flex1 } from 'scy/flex.mod.scss';
import { TextButton } from 'scy/buttons';
import { LightHR } from 'scy/HR';
import styles from './styles.mod.scss';

function PromoList({ userPromo, selectedPromo, select }) {
  return (
    <ul className={styles.list}>
      {!!userPromo.credit && (
        <PromoListItem
          isCredit
          value={`$${userPromo.credit.balance}`}
          title="Available Gift Credit"
          subtitle={`$${userPromo.credit.balance}`}
          isSelected={selectedPromo && selectedPromo.value_type === 'credit'}
          onClick={() => select({ credit: userPromo.credit })}
        />
      )}

      {(userPromo.codes || []).map(item => (
        <PromoListItem
          item={item}
          key={item.code}
          value={displayValue(item)}
          title={item.label}
          subtitle={item.desc}
          isSelected={selectedPromo && selectedPromo.code === item.code}
          onClick={() => select(item)}
        />
      ))}
    </ul>
  );
}

function PromoListItem({
  value,
  title,
  subtitle,
  isCredit,
  isSelected,
  onClick
}) {
  return (
    <li
      className={classnames(styles.listItem, {
        [styles.creditListItem]: isCredit,
        [styles.selectedListItem]: isSelected
      })}
      onClick={isSelected ? null : onClick}
    >
      <H5
        tag="div"
        className={classnames(styles.value, {
          [styles.credit]: isCredit,
          [styles.selectedValue]: isSelected
        })}
      >
        {value}
      </H5>
      <div className={flex1}>
        <H5 uppercase tag="div">
          {title}
        </H5>
        <Small tag="div">{subtitle}</Small>
      </div>
      <Small tag="div">{isSelected ? 'Selected' : 'Select'}</Small>
    </li>
  );
}

function displayValue(promo) {
  if (!promo) return '';
  switch (promo.value_type) {
    case '%':
      return `${100 * promo.value}%`;
    case 'hour':
      return promo.value === 1 ? `${promo.value} HR` : `${promo.value} HRS`;
    default:
      return `$${promo.value}`;
  }
}

class Promo extends React.Component {
  constructor(props) {
    super(props);
    this.select = this.select.bind(this);
    this.remove = this.remove.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && !!this.props.user) {
      this.props.loadPromos();
    }
  }

  select(item) {
    if (this.props.selectPromo) {
      this.props.selectPromo(item);
      track('Coupon Applied', {
        order_id: this.props.orderId,
        coupon_id: item.code,
        coupon_name: item.desc,
        discount: item.val
      });
    }
    window.setTimeout(() => this.close(), 500);
  }

  remove() {
    this.props.removePromo();
    window.setTimeout(() => this.close(), 500);
  }

  close() {
    this.props.showPromo(false);
    this.props.showedPromo();
  }

  render() {
    const {
      selectPromo,
      removePromo,
      userPromo,
      selectedPromo,
      linkPromo,
      show,
      user,
      orderId
    } = this.props;

    const promoSelectable =
      !!selectPromo && userPromo.codes && !!userPromo.codes.length;

    return (
      <Modal isOpen={linkPromo || show} handleClose={this.close} size="small">
        <LightBackground className={padding.sm}>
          {!user ? (
            <Body marginClass={margin.sm}>
              You must log in or create an account before adding a promo code.
            </Body>
          ) : (
            <div>
              <H5
                uppercase
                tag="h2"
                className={textCenter}
                marginClass={`${margin.top_sm} ${margin.bottom_sm}`}
              >
                Promos & Discounts
              </H5>

              <PromoForm
                placeholder="Enter a Promo Code or Gift Card"
                orderId={orderId}
                onSuccess={promo => this.select(promo)}
              />

              {promoSelectable && (
                <>
                  <LightHR />
                  <PromoList
                    userPromo={userPromo}
                    selectedPromo={selectedPromo}
                    select={promo => this.select(promo)}
                  />
                </>
              )}

              {!!selectedPromo && !!removePromo && (
                <>
                  <LightHR />
                  <SecondarySmallUppercase tag="div" className={textCenter}>
                    <TextButton
                      className={margin.sm}
                      onClick={() => this.remove()}
                    >
                      Remove Promo Code
                    </TextButton>
                  </SecondarySmallUppercase>
                </>
              )}
            </div>
          )}
        </LightBackground>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    userPromo: state.promo,
    show: state.promo.show,
    linkPromo: state.link.promo,
    user: state.login.user
  };
}

export default connect(
  mapStateToProps,
  {
    showPromo,
    showedPromo,
    loadPromos
  }
)(Promo);
